module.exports = __webpack_public_path__ + "img/reading-stages-table.29247c5a.png";